import gql from 'graphql-tag';

const ChefBlogQuery = {
  getRecipesVideoCodes: gql`
    query getRecipesVideoCodes {
      getRecipesVideoCodes
    }
  `,
  getChefInfo: gql`
    query getBlogItems {
      getBlogItems(setType: 3) {
        id
        title
        text
        attachmentsItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  `,
  getPopularArticles: gql`
    query getPopularArticles(
      $page: Int
      $setLimit: Int
      $imageSizeFilter: String
    ) {
      getPopularArticles(
        page: $page
        setLimit: $setLimit
        imageSizeFilter: $imageSizeFilter
      ) {
        totalCount
        articlesItems {
          id
          title
          attachmentsStretchItem {
            tempFullFilePath
          }
          attachmentsItem {
            cacheItem {
              filePath
            }
          }
        }
      }
    }
  `,
  getPopularRecipes: gql`
    query getPopularRecipes($setLimit: Int, $page: Int) {
      getRecipesPopular(setLimit: $setLimit, page: $page) {
        relProfile {
          profileItem {
            title
          }
        }
        id
        isFavorite
        title
        rating
        comments_number
        # text
        author
        date
        identifyIdURI
        recipes_difficult #  иконка с шапкой повара. от 1-го до 5
        slozhnostItem {
          id
          title
        }
        cooking_time # время приготовления
        rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
        serving # порции
        bludoItem {
          id
          title
        }
        attachmentsItem {
          cacheItem {
            filePath # путь карлито
          }
        }
      }
    }
  `
};

export default ChefBlogQuery;
